<script setup lang="ts">
import Typography from '../../_01_atoms/components/Typography.vue';

interface Tab {
  name: string,
  path: string,
}

interface Props {
  tabs: Tab[],
  title: string,
}

defineProps<Props>();
</script>

<template>
  <nav class="tabs-menu">
    <Typography class="tabs-menu__title" variant="content-heading-pay">
      {{ title }}
    </Typography>
    <div class="tabs-menu__links">
      <router-link
        v-for="tab in tabs"
        :key="tab.path"
        :to="tab.path"
        class="tab-item"
      >
        <Typography variant="body" color="gray-darker">
          {{ tab.name }}
        </Typography>
      </router-link>
    </div>
  </nav>
</template>
